'use strict';
module.exports = {};



// WEBPACK FOOTER //
// ./node_modules/canvg/node_modules/core-js/internals/iterators.js